import type { IPhaseTimersSchema } from './schema';

export const DEFAULT_PHASE_TIMERS: IPhaseTimersSchema = {
  introPhase: 30,
  readingPhase: 0,
  stationPhase: 0,
  examinerPhase: 0,
};

const isRecord = (value: unknown): value is Record<string, unknown> =>
  value !== null && typeof value === 'object' && !Array.isArray(value);

const parsePositiveInt = (value: unknown): number | undefined => {
  const num = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(num) || num < 1) return undefined;
  return Math.floor(num);
};

export const parsePhaseTimersFromApi = (json: unknown): IPhaseTimersSchema => {
  if (!isRecord(json)) {
    return { ...DEFAULT_PHASE_TIMERS };
  }

  const introPhase = parsePositiveInt(json.introPhase) ?? DEFAULT_PHASE_TIMERS.introPhase;
  const readingPhase = parsePositiveInt(json.readingPhase) ?? DEFAULT_PHASE_TIMERS.readingPhase;
  const stationPhase = parsePositiveInt(json.stationPhase) ?? DEFAULT_PHASE_TIMERS.stationPhase;
  const examinerPhase = parsePositiveInt(json.examinerPhase) ?? DEFAULT_PHASE_TIMERS.examinerPhase;

  return { introPhase, readingPhase, stationPhase, examinerPhase };
};

export const phaseTimersToApi = (timers: IPhaseTimersSchema) => ({
  introPhase: timers.introPhase,
  readingPhase: timers.readingPhase,
  stationPhase: timers.stationPhase,
  examinerPhase: timers.examinerPhase,
});
